import { createFileRoute } from '@tanstack/react-router'
import { SetupAuthenticatorPage } from '@/features/auth'

/** `/login/setup-authenticator` — Step 2 of 4: scan the TOTP QR code. */
export const Route = createFileRoute('/login/setup-authenticator/')({
  component: SetupAuthenticatorPage,
})
